import { Typography, styled } from '@mui/material';
import { WarningCircle } from '@phosphor-icons/react';
import type { ErrorOverlayProps } from './types';
import { t } from '@lingui/macro';

export const ErrorOverlay = ({ sx, error, width, height }: ErrorOverlayProps) => {
  return (
    <OverlayRoot height={height} width={width} data-testid="error-overlay">
      <Overlay sx={sx}>
        <Typography
          variant="bodyLarge"
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}
        >
          <WarningCircle size={28} />
          Error
        </Typography>
        <Typography variant="bodyMedium">{error?.message || t`Error loading image`}</Typography>
      </Overlay>
    </OverlayRoot>
  );
};

const OverlayRoot = styled('div')<{
  width?: number | '100%' | 'auto';
  height?: number | '100%' | 'auto';
}>(({ theme, width, height }) => ({
  position: width || height ? 'relative' : 'absolute',
  inset: '0 0 0 0',
  borderColor: theme.palette.divider,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#E5E5E5',
  width: width || '100%',
  height: height || 'auto',
}));

const Overlay = styled('div')(({ theme }) => ({
  padding: theme.spacing(3),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  alignItems: 'center',
}));
